import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useCanSeeTmBackedComplianceScreen } from "./-components/is-compliance-enabled";
import { TransactionMonitoringCaseListRoute } from "../_transaction-monitoring/-components/transaction-monitoring-list-route";

export const Route = createFileRoute(
  "/(app)/_main-layout/_compliance/compliance/action-required",
)({
  component: ComplianceActionRequiredRoute,
});

function ComplianceActionRequiredRoute() {
  const tmBackedCompliance = useCanSeeTmBackedComplianceScreen();
  const navigate = useNavigate();
  useEffect(() => {
    if (!tmBackedCompliance) {
      void navigate({ to: "/compliance", replace: true });
    }
  }, [navigate, tmBackedCompliance]);
  return tmBackedCompliance ? (
    <TransactionMonitoringCaseListRoute statusFilter="needs_you" />
  ) : null;
}
